<div class="dropdown-wrapper relative w-full">
  <!-- Botón trigger del dropdown -->
  <button
    type="button"
    class="dropdown-trigger w-full h-12 flex items-center justify-between px-3 bg-transparent border-1.5 rounded-xl text-sm font-normal cursor-pointer outline-none transition-all duration-200 hover:shadow-dropdown-hover"
    [class.text-blue-deep]="hasValue"
    [class.text-gray-500]="!hasValue"
    [class.border-blue-deep]="!isOpen"
    [class.border-blue-bright]="isOpen"
    (click)="toggleDropdown()"
    [attr.aria-expanded]="isOpen"
  >
    <span class="flex items-center gap-2 flex-1">
      @if (selectedItem?.icon) {
        <i [class]="selectedItem!.icon + ' icon-small-medium'"></i>
      }
      <span>{{ displayValue }}</span>
    </span>
    <i
      class="icon-flecha-abajo icon-small flex-shrink-0 transition-transform duration-200 text-blue-deep"
      [class.rotate-180]="isOpen"
    ></i>
  </button>

  <!-- Panel desplegable -->
  @if (isOpen) {
    <div
      class="absolute left-0 w-full max-h-60 overflow-y-auto bg-white z-dropdown rounded-xl border-1.5 border-blue-300 shadow-sm mt-1 py-2 px-1"
    >
      <ul class="list-none p-0 m-0">
        @for (item of items; track item.value) {
          <li class="p-0 m-0">
            <button
              type="button"
              (click)="onSelect(item)"
              (keydown.enter)="onSelect(item)"
              (keydown.space)="onSelect(item)"
              [attr.aria-label]="'Seleccionar ' + getDisplayText(item)"
              class="w-full p-2 cursor-pointer bg-transparent border-none text-left rounded-lg transition-colors duration-200 hover:bg-blue-glow"
              [class.bg-blue-glow]="selectedItem?.value === item.value"
              [class.font-semibold]="selectedItem?.value === item.value"
            >
              @if (useAvatar && item.name && item.lastName) {
                <app-avatar
                  [name]="item.name + ' ' + item.lastName"
                  [label]="item.email || ''"
                />
              }
              @if (!useAvatar) {
                <div
                  class="flex items-center gap-2 p-2 text-blue-deep text-sm w-full"
                >
                  @if (item.icon) {
                    <i
                      [class]="item.icon + ' icon-small-medium flex-shrink-0'"
                    ></i>
                  }
                  <span class="flex-1">{{ item.label }}</span>
                </div>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  }
</div>
